module.exports = __webpack_public_path__ + "img/1511200775.99992db6.jpg";